import { E, pipe, t, TE } from '@packages/prelude'
import * as domain from '@packages/domain'
import { OrderData } from '~/types'

const OrderResponse = t.type({
  id: t.string,
  realId: t.number,
  message: t.string,
  submissionType: domain.SubmissionType.Type
})

export type OrderResponse = t.TypeOf<typeof OrderResponse>

export const createOrder = (orderData: OrderData): TE.TaskEither<Error, OrderResponse> =>
  pipe(
    TE.tryCatch(
      () =>
        fetch('/wp-json/htc/v1/orders', {
          method: 'POST',
          headers: {
            'X-WP-Nonce': window.htcConfig.nonce,
            'Content-Type': 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            email: orderData.email,
            configuration_data: JSON.stringify(orderData.configurationData),
            configuration_id: orderData.configuration.id,
            product_id: orderData.productId,
            submission_type: orderData.submissionType,
            configuration_title: orderData.configuration.title,
            ...(orderData?.paymentType !== undefined && { payment_type: orderData.paymentType }),
            ...(orderData?.request !== undefined && { request: orderData.request })
          })
        }),
      error => new Error(`Network error: ${String(error)}`)
    ),
    TE.chain(response => {
      if (response.status !== 201) {
        return TE.left(new Error(`HTTP ${response.status}: ${response.statusText}`))
      }

      return TE.tryCatch(
        () => response.json(),
        error => new Error(`JSON error: ${String(error)}`)
      )
    }),
    TE.chainEitherK(response =>
      pipe(
        OrderResponse.decode({
          id: response.id,
          realId: response.real_id,
          message: response.message,
          submissionType: response.submission_type
        }),
        E.mapLeft(errors => new Error(errors.join(', ')))
      )
    )
  )
